<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                        <Description term="编号：">
                            {{detail.sn}}
                        </Description>
                        <Description term="项目：">
                            {{detail.project_name}}
                        </Description>
                        <Description term="客户：">
                            {{detail.company}}
                        </Description>
                        <Description term="状态：">
                            <Badge v-if="detail.status === 1" color="blue" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 2" color="orange" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 4" color="green" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 3" color="red" :text="detail.status_name" />
                            <Badge v-else color="#999999" text="其他" />
                        </Description>
                        <Description term="驳回原因：" v-if="detail.status === 3">
                            {{detail.object_remark}}
                        </Description>
                        <Description term="驳回时间：" v-if="detail.status === 3">
                            {{detail.object_time}}
                        </Description>
                        <Description term="收款类型：">
                            <Tag v-if="detail.type_id === 1" color="blue">{{detail.type_name}}</Tag>
                            <Tag v-else-if="detail.type_id === 2" color="orange">{{detail.type_name}}</Tag>
                            <Tag v-else-if="detail.type_id === 3" color="green">{{detail.type_name}}</Tag>
                            <Tag v-else-if="detail.type_id === 4" color="purple">{{detail.type_name}}</Tag>
                        </Description>
                        <Description term="计划收款：">
                            {{detail.is_plan === 1 ? '是':'否'}}
                        </Description>
                        <Description term="计划收款时间：" v-if="detail.is_plan == 1">
                            {{detail.plan_time}}
                        </Description>
                        <Description term="不含税金额：">
                            <Tag>{{detail.money}}</Tag>
                        </Description>
                        <Description term="费率：">
                            <Tag>{{detail.tax_rate}} %</Tag>
                        </Description>
                        <Description term="税费：">
                            <Tag>{{detail.tax_money}}</Tag>
                        </Description>
                        <Description term="含税金额：">
                            <Tag color="blue">{{detail.true_money}}</Tag>
                        </Description>
                        <Description term="到账金额：" v-if="detail.status === 4">
                            <Tag color="green">{{detail.get_money}}</Tag>
                        </Description>
                        <Description term="到账银行：" v-if="detail.status === 4">
                            {{detail.get_bank_info.name}}{{detail.get_bank_info.account}}
                        </Description>
                        <Description term="到账日期：" v-if="detail.status === 4">
                            {{detail.get_date}}
                        </Description>
                        <Description term="是否需要发票：">
                            {{detail.is_invoice !== 1 ? '需要':'不需要'}}
                        </Description>
                        <Description term="发票抬头：" v-if="detail.is_invoice !== 1">
                            {{detail.inv_head ?? '-'}}
                        </Description>
                        <Description term="发票号：" v-if="detail.is_invoice !== 1">
                            {{detail.inv_num ?? '-'}}
                        </Description>
                        <Description term="发票地址：" v-if="detail.is_invoice !== 1">
                            {{detail.inv_address ?? '-'}}
                        </Description>
                        <Description term="发票电话：" v-if="detail.is_invoice !== 1">
                            {{detail.inv_phone ?? '-'}}
                        </Description>
                        <Description term="发票银行：" v-if="detail.is_invoice !== 1">
                            {{detail.inv_bank ?? '-'}}
                        </Description>
                        <Description term="申请人：">
                            {{detail.apply_name}}
                        </Description>
                        <Description term="申请时间：">
                            {{detail.apply_time}}
                        </Description>
                        <Description term="审核人：" v-if="detail.status === 2 || detail.status === 4">
                            {{detail.draw_name}}
                        </Description>
                        <Description term="审核时间：" v-if="detail.status === 2 || detail.status === 4">
                            {{detail.draw_time}}
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.status === 4">
                        <Description term="到账凭证">
                            <div class="uploads">
                                <div class="upload-images" v-for="(item,index) in detail.get_voucher" :key="index" @click.stop="">
                                    <img :src="site_url + item">
                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                </div>
                            </div>
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                        <Description term="备注信息：">
                            {{detail.remark}}
                        </Description>
                    </DescriptionList>
                </Col>
            </Row>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {getIncomeDetail} from "@/apis/income";

export default {
    name: 'IncomeShow',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '收款详情',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : ''
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getIncomeDetail(id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(id){
            this.isBox = true;
            if(id){
                this.GetDetail(id);
            }
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
